module.exports = __webpack_public_path__ + "static/img/interest06.a7d8ed5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/my-irish-date/interests_images/interest06.png
// module id = vcFy
// module chunks = 0